import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Aesthetic%20flat%20lay%20fashion%20lifestyle%20collection%20sneakers%20hoodie%20watch%20sunglasses%20bag%20on%20warm%20cream%20textured%20linen%20soft%20natural%20morning%20light%20minimal%20editorial%20photography%20clean%20composition%20high%20detail%20warm%20neutral%20tones&width=1600&height=900&seq=kakobuy-hero-v2&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/60" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-20 md:py-28 text-center">
        <div className="max-w-4xl mx-auto space-y-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 border border-background-100/20 backdrop-blur-sm">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" />
            <span className="text-sm text-background-100 font-medium">
              Aktualizowane listy produktów 2026
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight text-balance">
            Kakobuy Spreadsheet Polska – Największa Lista Najlepszych Produktów z Chin
          </h1>

          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto leading-relaxed">
            Odkrywaj tysiące sprawdzonych produktów, najlepsze okazje, linki zakupowe oraz aktualne Kakobuy Spreadsheet w jednym miejscu.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-4 text-base font-semibold bg-primary-500 text-background-50 rounded-xl hover:bg-primary-600 transition-all whitespace-nowrap shadow-lg shadow-primary-500/25"
            >
              {t('cta_spreadsheet')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-4 text-base font-semibold bg-background-50 text-foreground-950 rounded-xl hover:bg-background-100 transition-all whitespace-nowrap border border-background-200/50"
            >
              {t('cta_buy_now')}
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 pt-4 text-sm text-background-200/80">
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-500" />
              {t('trust_updated')}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-500" />
              {t('trust_guides')}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-500" />
              {t('trust_prices')}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-accent-500" />
              {t('trust_safe')}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}